(function () {
    'use strict';

    angular
        .module('app')
        .directive('navigationTakeover', navigationTakeover);

    navigationTakeover.$inject = ['$window'];

    function navigationTakeover($window) {
        // Usage:
        //     <navigationTakeover></navigationTakeover>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {

            $(document).ready(function () {

                $(".btn.dropbtn").mouseover(function () {
                    $(".menu-tab-inner").removeClass("active");
                    $(".menu-tab-inner:first-child").addClass("active");
                    $(".tab-content:first-child").css("display", "block");

                });
                jQuery(".menu-nav-inner").each(function () {
                    $(".menu-tab-inner").mouseover(function (event) {
                        //event.preventDefault();
                        $("#tabbed-content .tab-content").hide();
                        $($(this).attr("data-tab-id")).show();
                    });
                });
                //green border
                $(".menu-tab-inner").mouseover(function (event) {
                    //event.preventDefault();
                    $(".menu-tab-inner").removeClass("active");
                    $(this).addClass("active");
                });

                (function IIFE($) {
                    $('.nav-item a[href*="#"]').on('click', function (e) {
                        //e.preventDefault();
                    });

                    $.fn.simpleAccordion = function () {
                        this.on("click", ".accordion__control", function () {

                            // Toggle the panel next to the item that was clicked
                            $(this).toggleClass("accordion__control--active").next().slideToggle();

                        });
                        // shows/hides navigation’s popover if class "expanded"
                        $('.nav-default li.nav_item').click(function(e) {
                            //e.stopImmediatePropagation();

                            resetNavCss();
                            showHideNav();
                            
                        });

                        $('span.menu.icon-menu').click(function() {
                            if ($('.nav-default').hasClass('expanded')) {
                                $(".gradient-resident").removeClass("whiteBlock");
                                $('.nav-default').removeClass('expanded');
                                window.setTimeout(function() { $('body').removeClass('no_scroll'); }, 200);
                            } else {
                                showNav();
                            }
                        });

                        // clicking anywhere inside navigation or heading won’t close navigation’s popover
                        $('#navigation').click(function(event) {
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                        });

                        //reset menu-nav and tab-content css
                        function resetNavCss() {
                            //remove active class from all menu-tab-inner divs
                            $(".menu-tab-inner").removeClass("active");

                            //hide all tabbed-content
                            $("#tabbed-content .tab-content").hide();

                            //add active class to first menu-tab-inner div
                            $(".menu-nav-inner .first-menu-tab").addClass("active"); 

                            //show first tabbed-content
                            $("#tabbed-content .first-content").show();
                            
                        }

                        // checks if navigation’s popover is shown
                        function showHideNav() {
                            if ($('.nav-default').hasClass('expanded')) {

                                hideNav();
                            } else {
                                showNav();
                            }
                        }

                        // shows the navigation’s popover
                        function showNav() {
                            $('.nav-default').removeClass('invisible').addClass('expanded');
                            $("li.search-item").removeClass("open");
                            $(".search-window").addClass("hide");
                            $(".gradient-resident").addClass("whiteBlock");
                            $('#container').addClass('blurred');
                            window.setTimeout(function () { $('body').addClass('no_scroll'); }, 100); // Firefox hack. Hides scrollbar as soon as menu animation is done                            
                        }

                        // hides the navigation’s popover
                        function hideNav() {
                            $('.nav-default').removeClass('hide').addClass('show');
                            $('#container').removeClass('blurred');                            

                            $('#navigation a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable
                            $('.icon').blur(); // deselect icon when navigation is hidden
                        }

                        $(".nav li.nav_item a").on("click", function () {
                            $(".nav li.nav_item a").removeClass("active");
                            $(this).addClass("active");
                        });

                        // Return jQuery object for method chaining
                        return this;

                    }
                })(jQuery);

                $(".accordion").simpleAccordion();



                /*MOBILE NAV SCRIPTS */

                if ($(window).width() <= 992) {
                    $('li.menu-item-has-children a.show-sub').on("click", function () {
                        $('nav').addClass('site-navigation open');
                        $(this).next('.sub-menu').addClass('open').delay(2000);;
                    });

                    $('.sub-menu').find('.arrow-swipe-left').on("click", function (e) {
                        e.stopPropagation();
                        $(this).parent().closest('.sub-menu').removeClass('open');
                        $('nav').removeClass('open');
                    });
                }


                //Mobile Navigation
                $('div#icon').click(function () {
                    $('div#icon').toggleClass('mobile-open');
                    $('div#a').toggleClass('a');
                    $('div#b').toggleClass('c');
                    $('div#c').toggleClass('b');

                    if ($('div#icon').hasClass("mobile-open")) {
                        window.setTimeout(function () { $('body').addClass('no_scroll'); }, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
                        $('.nav-default').addClass('expanded').removeClass('invisible');
                        $(".icon-logo.hide-desktop").find("img").addClass("hidden");
                    } else {
                        if (!$('.div#icon').hasClass("mobile-open")) {
                            $('.nav-default').removeClass('expanded').addClass('invisible');
                            window.setTimeout(function () { $('body').removeClass('no_scroll'); }, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
                            $(".icon-logo.hide-desktop").find("img").removeClass("hidden");
                        }
                    }
                });

            });



            /*Hide/SHow*/
			// bubble callouts
            (function (document, window, $) {

                $(document).ready(function () {
                    new WOW().init();


                    function hideAll(callback) {
                        var count = 0;
                        $('.core-p').fadeOut(400, function () {
                            count++;
                            if (count === 5)
                                callback();
                        });
                    }
                });
                
            }(document, window, jQuery));
        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./Views/Shared/Partials/SiteHeader/_navigationTakeover.js
// module id = 31
// module chunks = 0